// extracted by mini-css-extract-plugin
export default {"couponTabs":"Coupon_couponTabs__8L9cx","themeBtn":"Coupon_themeBtn__UDMUq"};